import { motion } from "framer-motion";
import { FaBuilding, FaLocationDot } from "react-icons/fa6";
import resumeData from "../../data/resumeData";

const ExperienceTimeline = ({ darkMode = false }) => {
  return (
    <section id="experience" className={`relative overflow-hidden py-14 sm:py-16 transition-colors duration-500 ${darkMode ? 'bg-stone-950' : 'bg-[#f4f1ea]'}`}>
      <div className="relative mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.45 }}
          className="grid gap-6 lg:grid-cols-[0.85fr_1.15fr] lg:items-end"
        >
          <div>
            <p className="text-xs font-black uppercase tracking-[0.24em] text-teal-800 dark:text-teal-300">Experience</p>
            <h2 className="mt-3 max-w-3xl text-3xl font-black leading-tight text-stone-950 dark:text-white sm:text-4xl">
              Delivery across Germany, Belgium, and India.
            </h2>
          </div>
          <p className="max-w-2xl border-l-4 border-amber-400 pl-5 text-sm leading-7 text-stone-700 dark:text-stone-300">
            Allianz and AXA highlight architecture and security-led engineering; BayWa covers current platform operations and AI-assisted support. Technical lead titles reflect ownership on those programmes.
          </p>
        </motion.div>

        <div className="relative mt-10">
          <div className={`absolute left-[1.05rem] top-0 bottom-0 hidden w-px lg:block ${darkMode ? 'bg-stone-700' : 'bg-stone-950/15'}`} />
          <div className="space-y-5">
            {resumeData.experience.map((item, index) => (
              <motion.article
                key={`${item.role}-${item.period}`}
                initial={{ opacity: 0, x: -40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.45, delay: index * 0.08 }}
                className={`group relative grid gap-4 rounded-2xl border p-4 sm:p-5 lg:ml-12 lg:grid-cols-[200px_minmax(0,1fr)] ${darkMode ? 'border-stone-700 bg-stone-800/50 hover:border-teal-400/60' : 'border-stone-950/10 bg-white hover:border-teal-700/30'}`}
              >
                <div className={`absolute -left-[2.65rem] top-7 hidden h-4 w-4 rounded-full border-4 lg:block ${darkMode ? 'border-stone-800 bg-teal-500' : 'border-[#f4f1ea] bg-teal-600'}`} />
                <div className={`rounded-xl p-4 text-white ${darkMode ? 'bg-stone-700' : 'bg-stone-950'}`}>
                  <p className="text-[0.65rem] font-black uppercase leading-5 tracking-[0.16em] text-teal-200">
                    {item.period}
                  </p>
                  <div className={`mt-5 inline-flex rounded-full px-2.5 py-1 text-[0.65rem] font-black uppercase tracking-[0.16em] ${darkMode ? 'bg-amber-600 text-stone-900' : 'bg-amber-300 text-stone-950'}`}>
                    {item.client || "Enterprise"}
                  </div>
                </div>
                <div>
                  <h3 className={`text-xl font-black leading-tight ${darkMode ? 'text-white' : 'text-stone-950'}`}>{item.role}</h3>
                  <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm font-semibold text-stone-700 dark:text-stone-300">
                    <span className="inline-flex items-center gap-2">
                      <FaBuilding className="text-teal-700" />
                      {item.company}
                    </span>
                    <span className="inline-flex items-center gap-2">
                      <FaLocationDot className="text-teal-700" />
                      {item.location}
                    </span>
                  </div>
                  <ul className={`mt-4 grid gap-2 text-sm leading-6 ${darkMode ? 'text-stone-300' : 'text-stone-700'} md:grid-cols-2`}>
                    {item.highlights.map((highlight) => (
                      <li key={highlight} className="flex items-start gap-2.5">
                        <span className="mt-2 inline-flex h-1.5 w-1.5 shrink-0 rounded-full bg-teal-700" />
                        <span>{highlight}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceTimeline;
